module.exports = __webpack_public_path__ + "static/x49-89950db38d814e5597f1e4a51a90455a.png";